<template>
	<div id="login">
		<div class="login d-flex jc-center flex-column">
			<div class="content-box d-flex">
				<div class="img"></div>
				<div class="rightForm">
					<el-form ref="form" :model="form" :rules="rules" label-position="top" hide-required-asterisk
						@keyup.enter.native="onSubmit">
						<div class="top d-flex jc-center">
							<img src="~@/assets/avatar.png" />
							<h2 class="ml-3">云端中央空调互联智控系统（销售端）</h2>
							<i></i>
							<div class="welcome flex-vertical">
								<h4 style="font-size: 20px;">欢迎回来</h4>
								<p>Welcome Back!</p>
							</div>
						</div>
						<el-form-item prop="username" label="用户名">
							<el-input placeholder="请输入您的用户名" v-model="form.username" clearable>
							</el-input>
						</el-form-item>
						<el-form-item prop="password" label="密码">
							<el-input placeholder="请输入您的密码" v-model="form.password" show-password clearable>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="onSubmit">登录</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="showCompany mt-5">
				<p>合作厂商</p>
				<ul class="img-list d-flex jc-around">
					<li v-for="item in vendorList" :key="item.name">
						<img :src="item.img" />
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	export default {
		data() {
			return {
				vendorList: [{
						img: require("@/assets/index/huadong.png"),
						name: "华东医药",
					},
					{
						img: require("@/assets/index/zhejiang.png"),
						name: "浙江医药",
					},
					{
						img: require("@/assets/index/yingte.png"),
						name: "英特医药",
					},
					{
						img: require("@/assets/index/nanjing.png"),
						name: "南京医药",
					},
					{
						img: require("@/assets/index/jingxin.png"),
						name: "京新医药",
					},
					{
						img: require("@/assets/index/gaoji.png"),
						name: "高济医药",
					},
					{
						img: require("@/assets/index/guangyao.png"),
						name: "广药集团",
					},
					{
						img: require("@/assets/index/guoyao.png"),
						name: "国药集团",
					},
					{
						img: require("@/assets/index/dashenlin.png"),
						name: "大参林医药",
					},
					{
						img: require("@/assets/index/luyan.png"),
						name: "鹭燕医药",
					},
				],
				form: {
					username: "",
					password: "",
				},
				rules: {
					username: {
						validator: (rule, value, callback) => {
							if (value === "") {
								callback(new Error("请输入用户名"));
							} else {
								callback();
							}
						},
					},
					password: {
						validator: (rule, value, callback) => {
							if (value === "") {
								callback(new Error("请输入密码"));
							} else {
								callback();
							}
						},
					},
				}
			};
		},
		components: {

		},
		mounted() {

		},
		methods: {
			onSubmit() {
				this.$refs.form.validate((valid) => {
					if (!valid) {
						return false;
					}
					this.$axios.post("/api/login",{
						username: this.form.username,
						password: this.form.password
					}).then(res => {
						if (process.env.NODE_ENV === "production") {
						  Cookies.set('token', res.data.data.token,{expires: 7, domain: "hzng-iot.com",})
						} else {
						  Cookies.set('token', res.data.data.token)
						}
						this.$router.replace("/index");
					})
				});
			}
		},
	};
</script>

<style lang="scss">
	#login {
		background-image: url('~@/assets/index/bg.png');
		
		.el-input--suffix .el-input__inner {
			background-color: #FFF;
			color: #606266;
			border: 1px solid #DCDFE6;
		}

		.login {
			width: 1920px;
			height: 100vh;
			background: linear-gradient(rgba(255, 255, 255, 0), #fff 80%);
			align-items: center;

			.content-box {
				width: 75%;
				height: 600px;
				background-color: #fff;

				.img {
					width: 60%;
					height: 600px;
					background-image: url('~@/assets/index/login.jpg');
					background-size: cover;
					background-position: 0 0;
				}

				.rightForm {
					width: 40%;
					padding: 5%;

					.top{
						img {
							width: 49px;
						}
						
						h2 {
							font-family: "YouSheBiaoTiHei";
							width: 180px;
							font-size: 20px;
							color: #4293f4;
							font-weight: bold;
							line-height: 25px;
						}
						
						i {
							width: 1px;
							height: 50px;
							background-color: rgba($color: #000, $alpha: 0.25);
							margin: 0 24px;
						}
						
						.welcome {
							text-align: center;
						
							h4 {
								line-height: 30px;
								font-weight: 500;
							}
						
							p {
								line-height: 20px;
								font-weight: 400;
							}
						}
					}
				}
			}

			.showCompany {
				width: 75%;
				min-width: 1000px;
				height: 250px;

				p {
					font-size: 0.25rem;
					height: 0.5rem;
					line-height: 0.5rem;
				}

				ul {
					width: 100%;
					flex-wrap: wrap;

					li {
						width: 265px;
						height: 85px;
						background-color: #fff;
						margin-bottom: 18px;
						padding: 20px 30px;

						img {
							width: 100%;
							height: 100%;
							object-fit: none;
						}
					}
				}
			}
		}
	}
</style>
